const RETURN_TO_BASE = new URL('https://aitoolly.invalid');

/**
 * Normalize an application-local return path and reject scheme-relative or
 * backslash-normalized external destinations. URL parsing is deliberately
 * shared by the client login page, auth callback, and Turnstile verify page so
 * none of the three can become an open redirect.
 */
export function safeInternalReturnTo(value: unknown, fallback: string): string {
  if (typeof value !== 'string' || !value.startsWith('/')) return fallback;
  try {
    const target = new URL(value, RETURN_TO_BASE);
    if (target.origin !== RETURN_TO_BASE.origin) return fallback;
    return `${target.pathname}${target.search}${target.hash}`;
  } catch {
    return fallback;
  }
}
